import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { type UpdateSupplierRelationshipMutationOptions } from './types';
import { updateSupplierRelationship } from './updateSupplierRelationship';

/**
 * React Query based custom hook for updating relationship fields of a supplier.
 *
 * Invalidates the supplier detail query for the affected data exchange ID on settle.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/update_supplier_relationship_suppliers_details__de_id__patch
 */
export const useMutationUpdateSupplierRelationship = (
  options?: UpdateSupplierRelationshipMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ deId, payload }) =>
      updateSupplierRelationship(deId, payload),
    onSettled(_data, _error, { deId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getDetail(deId),
      });
    },
    throwOnError: false,
    ...options,
  });
};
